import { IHeaderCommandBarItem } from "azure-devops-ui/HeaderCommandBar";
import { MenuItemType } from "azure-devops-ui/Menu";

export const commandBarItemsAdvanced: IHeaderCommandBarItem[] = [
    {
        iconProps: {
            iconName: "Download"
        },
        id: "testSave",
        important: true,
        onActivate: () => {
            alert("Example text");
        },
        text: "Download"
    },
    {
        iconProps: {
            iconName: "Share"
        },
        id: "testShare",
        onActivate: () => {
            alert("Example text");
        },
        text: "Share"
    },
    {
        iconProps: {
            iconName: "Refresh"
        },
        id: "testCreate",
        important: true,
        isPrimary: true,
        onActivate: () => {
            alert("This would normally trigger a modal popup");
        },
        text: "Revalidate"
    }
];
